
<template>
  <div>
    <!-- barra de navegacion -->
    <nav-bar :open.sync= "open" :menu="this.menuNavBar"/>
    <div style="position: relative; top: 65px;">
      <!--barra lateral-->
      <side-bar :open.sync= "open" :menu = 'this.menu'/>
      <div class="content" :class="{'content_sidebar': open}">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import NavBar from '@/components/NavBar'
import SideBar from '@/components/SideBar'
// import store from '@/store'

export default {
  computed: { },
  components: {
    NavBar,
    SideBar
  },
  data () {
    return {
      open: true,
      menu: [
        // presale
        {
          to: { path: '/presale' },
          title: 'Presale',
          icon: require('../components/icons/menu/PresaleIcon.vue').default,
          properties: {}
        },
        // trade
        {
          to: { path: '/trade' },
          title: 'Trade',
          icon: require('../components/icons/menu/TradeIcon.vue').default,
          properties: {},
          toggled: false,
          event: '',
          child: [
            {
              to: { path: '/trade/swap' },
              title: 'Swap',
              icon: require('../components/icons/menu/SwapIcon.vue').default,
              properties: {}
            },
            {
              to: { path: '/trade/liquidity' },
              title: 'Liquidity',
              icon: require('../components/icons/menu/LiquidityIcon.vue').default,
              properties: {}
            }
          ]
        },
        // earn
        {
          path: '/earn',
          to: { path: '/earn' },
          title: 'Earn',
          icon: require('../components/icons/menu/EarnIcon.vue').default,
          properties: {},
          toggled: false,
          event: '',
          child: [
            {
              to: { path: '/earn/liquidity-pools' },
              title: 'Liquidity Pools LP',
              icon: require('../components/icons/menu/PoolsLiquidityIcon.vue').default,
              properties: {}
            },
            {
              to: { path: '/earn/farming' },
              title: 'Farming',
              icon: require('../components/icons/menu/FarmingIcon.vue').default,
              properties: {}
            },
            {
              path: 'stake',
              to: { path: '/earn/stake/home' },
              title: 'Stake',
              icon: require('../components/icons/menu/StackingIcon.vue').default,
              properties: {},
              child: [
                {
                  path: 'document',
                  to: { path: '/earn/stake/document' },
                  title: 'Document',
                  icon: require('../components/icons/menu/StackingIcon.vue').default,
                  properties: {}
                }
              ]
            },
            {
              to: { path: '/earn/stake-team' },
              title: 'stake team',
              icon: require('../components/icons/menu/StackingIcon.vue').default,
              properties: {}
            }
          ]
        },
        // global Art
        {
          to: { path: '/global-art' },
          title: 'Global Art',
          icon: require('../components/icons/menu/GlobalArteIcon.vue').default,
          properties: {}
        },
        // Nexo City
        {
          to: { path: '/nexo-city' },
          title: 'Nexo City',
          icon: require('../components/icons/menu/NexoCityIcon.vue').default,
          properties: {}
        },
        // Smart Bot
        {
          to: { path: '/smart-bot' },
          title: 'Smart Bot',
          icon: require('../components/icons/menu/SmartBotIcon.vue').default,
          properties: {}
        },
        // Smart Wallet
        {
          to: { path: '/smart-wallet' },
          title: 'Smart Wallet',
          icon: require('../components/icons/menu/SmartWalletIcon.vue').default,
          properties: {}
        },
        // Play
        {
          to: { path: '/play' },
          title: 'Play',
          icon: require('../components/icons/menu/PlayIcon.vue').default,
          properties: {},
          toggled: false,
          event: '',
          child: [
            {
              to: { path: '/play/game' },
              title: 'Game',
              icon: require('../components/icons/menu/GameIcon.vue').default,
              properties: {}
            },
            {
              to: { path: '/play/Gambling' },
              title: 'Gambling',
              icon: require('../components/icons/menu/GamblingIcon.vue').default,
              properties: {}
            }
          ]
        }
      ],
      menuNavBar: []
    }
  },
  async created () {
    const path = await this.$router.currentRoute.path
    console.log('path', path)
    this.setMenuNavBar(path)
  },
  mounted () { },
  updated () { },
  methods: {
    setMenuNavBar (path) {
      this.menuNavBar = []
      const pathSplit = path.split('/')
      console.log('split', pathSplit)
      //
      if ('/' + pathSplit[1] + '/' + pathSplit[2] === '/earn/stake') {
        this.menuNavBar = [
          {
            to: { path: '/earn/stake/home' },
            title: 'Home',
            active: false
          },
          {
            to: { path: '/earn/stake/profile' },
            title: 'Profile',
            active: false
          },
          {
            to: { path: '/earn/stake/document' },
            title: 'Document',
            active: false
          }
        ]
        if (pathSplit[3] !== undefined) {
          this.menuNavBar.map(item => {
            if (item.title.toLowerCase() === pathSplit[3]) {
              item.active = true
            }
          })
        } else {
          // default
          this.menuNavBar[0].active = true
        }
      }
    }
  },
  watch: {
    $route (to, from) {
      this.setMenuNavBar(to.path)
    }
  }
}
</script>

<style scoped >
  div.content {
    padding: 0px 0px 16px 16px;
    background-color: #000000;
    position: fixed;
    height: 100%;
    width: 100%;
    overflow: auto;
    /*overflow-y:scroll;
    overflow-x:hidden;
    */
    padding-left: 0px;
    transition: padding-left 0.5s;
  }
  div .barra{
    background-color: #000;
  }
  .icon {
    color: #fff;
  }
  div.content.content_sidebar{
    /*padding-left: 250px;*/
  }

  /*sm  <576px */
  @media screen and (max-width: 575.99px) {
      div.content.content_sidebar{
        padding-left: 0px;
      }
  }
</style>
